import { Select } from 'antd';
import './TranslateDropdown.css';
import { ReactComponent as CustomSelectIcon } from '../../icons/icon-select-dropdown.svg';


const TranslateDropdown = ({ languageItems, currentLanguage, onSelect }) => {

    const onChange = (item) => {
        onSelect(item);
    }

    return (
        <div >
            <Select
                className='translate-dropdown-select'
                value={currentLanguage || 'English'}
                variant="borderless"
                options={languageItems.map(item => ({ label: item.label, value: item.key }))}
                onChange={onChange}
                suffixIcon={<CustomSelectIcon />}
            />
        </div>
    );
};

export default TranslateDropdown;
